import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { CheckoutScenario, PaymentInfo } from '~/types/booking'
import { PaymentIntentResponse } from '~/types/payment'
import { RootState } from '~/redux/store'

interface CheckoutState {
  paymentInfo: PaymentInfo | undefined
  paymentIntent: PaymentIntentResponse | undefined
  scenario: CheckoutScenario | undefined
}

const initialState: CheckoutState = {
  paymentInfo: undefined,
  paymentIntent: undefined,
  scenario: undefined,
}

const slice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setCheckoutScenario: (state, action: PayloadAction<CheckoutState['scenario']>) => ({
      ...state,
      scenario: action.payload,
    }),

    setPaymentInfo: (state, action: PayloadAction<CheckoutState['paymentInfo']>) => ({
      ...state,
      paymentInfo: action.payload,
    }),

    setPaymentIntent: (state, action: PayloadAction<CheckoutState['paymentIntent']>) => ({
      ...state,
      paymentIntent: action.payload,
    }),
  },
})

export const selectCheckoutScenario = (state: RootState): CheckoutState['scenario'] => {
  return state.checkout.scenario
}

export const selectIsCheckoutForSelfScenario = (state: RootState): boolean => {
  return state.checkout.scenario === CheckoutScenario.TUTOR_FOR_SELF
}

export const selectIsCheckoutForOtherScenario = (state: RootState): boolean => {
  return state.checkout.scenario === CheckoutScenario.TUTOR_FOR_OTHER
}

export const selectIsCheckoutForVideoChatScenario = (state: RootState): boolean => {
  return state.checkout.scenario === CheckoutScenario.VIDEO_CHAT
}

export const selectPaymentInfo = (state: RootState): CheckoutState['paymentInfo'] => {
  return state.checkout.paymentInfo
}

export const selectPaymentIntent = (state: RootState): CheckoutState['paymentIntent'] => {
  return state.checkout.paymentIntent
}

export const {
  setCheckoutScenario: setCheckoutScenarioActionCreator,
  setPaymentInfo: setPaymentInfoActionCreator,
  setPaymentIntent,
} = slice.actions

export default slice.reducer
